import React from 'react'
import './global.scss'
import {QueryClientProvider} from '@tanstack/react-query'
import { createRoot } from 'react-dom/client';
import App from './components/App';
import {queryClient} from "./components/ProductService";
import fetchCustomRearProductSync from "./services/CustomRearSeatsService";
import { preloadYearsSeed, preloadMakesSeed, debugMemorySeedKeys, getSeedFromMemory } from "./services/SeedPrefetchService";
import { initSentry } from "./services/sentry";

initSentry();

// Expose debug helpers for e2e tests.
if (typeof window !== "undefined") {
  window.__debugMemorySeedKeys = debugMemorySeedKeys;
  window.__getSeedFromMemory = getSeedFromMemory;
}

queryClient.prefetchQuery({
    queryKey: ["customRearProduct"],
    queryFn: fetchCustomRearProductSync,
    staleTime: 1000 * 60 * 30,
});

preloadYearsSeed();
preloadMakesSeed();

function mountApp(container) {
  createRoot(container).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>
  );
}

function waitForRoot() {
  const el = document.getElementById('root');
  if (el) {
    mountApp(el);
    return;
  }
  // #root may not exist yet when loaded via Shopify UI extension (Remote UI renders async)
  const observer = new MutationObserver(() => {
    const el = document.getElementById('root');
    if (el) {
      observer.disconnect();
      mountApp(el);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForRoot);
} else {
  waitForRoot();
}
